export const links = {
    yes: 'https://ocontabil.com/convite/superdigital/',
    no: 'https://ocontabil.com/comprar-carro-sem-entrada-agora/?utm_source=google',
    noFacebook: 'https://ocontabil.com/comprar-carro-sem-entrada-agora/?utm_source=facebook',
    terms: 'https://ocontabil.com/termos-de-uso/',
    disclaimer: 'https://ocontabil.com/disclaimer/',
    privacy: 'https://ocontabil.com/politica-de-privacidade/'
}


